<template>
  <v-app-bar fixed color="#162CA2" class="custom-header">
    <v-container d-flex>
      <!-- Logo -->
      <v-toolbar-title class="text-uppercase blue--text" style="cursor: pointer" @click="goToHomePage">
        <LogoNav />
      </v-toolbar-title>

      <!-- Spacer -->
      <v-spacer></v-spacer>

      <div class="d-flex align-center hc-nav-container">
        <div v-for="(menuItem, index) in menuItems" :key="index" class="hc-nav-content" @click="navigate(menuItem.router, '')">
          <span style="font-family: Poppins, sans-serif;">{{ menuItem.text }}</span>
          <Arrow v-if="menuItem.items.length" width="18" height="18" down />

          <div v-if="menuItem.text === 'Programs'" class="sub-menu programs-sub-menu" style="color: black;">
            <div style="display: inline-flex;">
              <!-- Left Side Menu -->
              <ul style="padding-left: 0px;padding-right: 10px;">
                <li v-for="(i, submenus) in menuItem.items" :key="submenus" class="sub-menu-column">
                  <div @mouseover="showSubMenu(i)" class="sub-menu-item" style="display: flex; justify-content: space-between; align-items: center; width: 150px;" :class="{ 'active': activeSubMenu === i.key }">
                    <div @click="navigateWithRouter(i.router, '')">{{i.text}} </div>
                    <Arrow v-if="i.isArrow" width="18" height="18" direct="right" />
                  </div>
                </li>
              </ul>

              <!-- Right Side Menu -->
              <div v-for="(i, submenus) in menuItem.items" :key="submenus" >
                <div v-if="titleSubMenu === i.text">
                  <h3 class="sub-menu-title">{{titleSubMenu}}</h3>
                  <p class="sub-menu-description">{{descSubMenu}}</p>
                  <div v-for="(a, classess) in i.classes" :key="classess.id" style="padding-top: 15px;">
                    <div @mouseover="hoverDetailClass(a)" class="sub-menu-label" :class="{ 'active': activeDetailClass === a.id }" @click="navigate(a.router, a.slug_name)">
                      {{a.name}}
                    </div>
                  </div>
                </div>
             </div>
            </div>
          </div>

          <div v-if="menuItem.text != 'Programs'" class="sub-menu">
            <ul style="padding-left: 5px;">
                <li v-for="(i, submenus) in menuItem.items" :key="submenus" class="sub-menu-column">
                  <div @mouseover="showMenu(i)" class="sub-menu-item" style="padding: 10px; align-items: center; width: 200px;" :class="{ 'active': activeSubMenu === i.key }" @click="navigate(i.router, '')">
                    {{i.text}}
                    <Arrow v-if="i.isArrow" width="18" height="18" direct="right" />
                  </div>
                </li>
              </ul>
          </div>
        </div>
      </div>

      <!-- Spacer -->
      <v-spacer></v-spacer>

      <!-- Language Selector and Login Button -->
      <div class="d-flex align-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="language-selector">
              <img v-if="$i18n.locale === 'id'" src="@/assets/icons/idn-flag.png" style="border-radius: 6px;"
                alt="Language Flag" width="25" height="20" />
              <img v-else src="@/assets/icons/eng-flag.png" style="border-radius: 6px;" alt="Language Flag" width="24"
                height="19" />
              {{ $i18n.locale == "id" ? "ID" : "EN" }}
              <Arrow width="18" height="18" down />
            </span>
          </template>
          <v-list>
            <div class="lang-ctn" @click="setLanguage('id')" style="width: 240px;">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                  <img src="@/assets/icons/idn-flag.png" style="border-radius: 6px;" alt="IDN" width="25" height="20" />
                  <span class="ml-2">Bahasa Indonesia </span>
                </div>
              </div>
              <v-radio-group v-model="$i18n.locale" class="language-option" dense>
                <v-radio value="id"></v-radio>
              </v-radio-group>
            </div>

            <div class="lang-ctn" @click="setLanguage('en')" style="width: 240px;">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                  <img src="@/assets/icons/eng-flag.png" style="border-radius: 6px;" alt="ENG" width="25" height="20" />
                  <span class="ml-2">English</span>
                </div>
              </div>
              <v-radio-group v-model="$i18n.locale" class="language-option" dense>
                <v-radio value="en"></v-radio>
              </v-radio-group>
            </div>
          </v-list>
        </v-menu>

        <v-btn depressed color="#FFDE59" class="btn-login-rounded ml-5" @click="goToLoginPage">
          <span class="text-capitalize font-weight-bold" style="font-family: Poppins, sans-serif;">{{ $t('navbarLogIn')
          }}</span>
        </v-btn>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import Arrow from "@/assets/icons/Arrow2.vue";
import LogoNav from "@/assets/icons/LogoNav.vue";

export default {
  components: {
    Arrow,
    LogoNav,
  },
  data() {
    return {
      is_login_show: true,
      activeSubMenu: "bootcamp",
      holdSet: false,
      hoveredItem: null,
      currentRoute: "",
      activeDetailClass: null,
      titleSubMenu: "Bootcamp",
      descSubMenu: "Digital acceleration program yang dirancang intensif untuk talent siap kerja.",
      menuItems: [
        {
          text: "Programs", key: "programs", items: [
            { text: "Bootcamp", key: "bootcamp", isArrow: true, router: "", desc: "Digital acceleration program yang dirancang intensif untuk talent siap kerja.",
              classes: [{
                id: 1,
                name: "Fullstack Web Development with Integration AI",
                slug_name: "fullstack-web-development-with-integration-ai",
                // fullstack-web-development-with-integration-ai
                router: "/class/bootcamp/",
              }],
            },
            { text: "Sertifikasi", key: "certification", isArrow: true, router: "", desc: "Digital acceleration program yang dirancang intensif untuk talent siap kerja dan mendapakan sertifikasi global sesuai bidang tertentu.",
              classes: [
                {
                  id: 1,
                  name: "Certified Big Data by Alicloud",
                  slug_name: "pelatihan-dan-sertifikasi-big-data-alibaba-cloud",
                  // certified-big-data-by-alicloud
                  router: "/certification/detail/",
                },
                {
                  id: 2,
                  name: "Certified Cloud Computing by Alicloud",
                  slug_name: "alibaba-cloud-computing-certification",
                  // certified-cloud-computing-by-alicloud
                  router: "/certification/detail/",
                },
                {
                  id: 3,
                  name: "Certified Junior Coder by BNSP",
                  slug_name: "junior-coder",
                  // certified-junior-coder-by-bnsp
                  router: "/certification/detail/",
                },
                {
                  id: 4,
                  name: "Certified Junior Web Developer by BNSP",
                  slug_name: "junior-web-programmer",
                  // certified-junior-web-developer-by-bnsp
                  router: "/certification/detail/",
                }]
            },
            { text: "Event", key: "event", isArrow: false, router: "/event", desc: "Tumbuh kembangkan keahlian Anda bersama komunitas profesional yang suportif." },
          ], router: "",
        },
        {
          text: "For Corporate", key: "corporate", items: [
            { text: "Collaboration Partner", key: 'collaborationpartner', router: "/corporate/collaboration" },
            { text: "Corporate Training", key: 'corporatetrainer', router: "/corporate/training" },
            { text: "Talent As A Service", key: 'talentasaservice', router: "/corporate/talent-service" },
            { text: "Technology Service", key: 'techservice', router: "/corporate/services" },
          ], router: "",
        },
        { text: "Digital Insight", key: "digitalInsight", items: [], router: "/blog" },
        {
          text: "Why HiColleagues", key: "whyHiColleagues", items: [
            { text: "About Us", key: 'aboutus', router: "/about" },
            { text: "Portfolio", key: 'portofolio', router: "/portfolio" },
            { text: "Alumni Story", key: 'alumni', router: "/testimony" },
          ], router: "",
        },
      ],
    };
  },
  methods: {
    goToHomePage() {
      sessionStorage.setItem("nav-item-active", 0);
      window.location.href = "/";
    },
    goToLoginPage() {
      window.location.href = "/login";
    },
    setLanguage(lang) {
      this.$i18n.locale = lang;
      sessionStorage.setItem("bahasa", lang);
    },
    navigate(route, slug) {
      if(route != ""){
        window.location.href = route+slug;
      }
    },
    navigateWithRouter(route, slug){
      if(route != ""){
        this.$router.push(route + slug);
      }
    },
    showSubMenu(i) {
      if (this.holdSet) return
      this.activeSubMenu = i.key;
      this.titleSubMenu = i.text;
      this.descSubMenu = i.desc
    },
    showMenu(i) {
      if (this.holdSet) return
      this.activeSubMenu = i.key;
    },

    hoverDetailClass(i) {
      if (this.holdSet) return
      this.activeDetailClass = i.id;
    }
  },
};
</script>

<style src="./css/header.css" scoped></style>
